import { render, staticRenderFns } from "./collectionCreate.vue?vue&type=template&id=6c5ba640&scoped=true"
import script from "./collectionCreate.vue?vue&type=script&lang=js"
export * from "./collectionCreate.vue?vue&type=script&lang=js"
import style0 from "./collectionCreate.vue?vue&type=style&index=0&id=6c5ba640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5ba640",
  null
  
)

export default component.exports